//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet } from '../../axios/axios.js'
import { MGT_TASK_CANCEL_REASON_OPTIONS } from './RequestMgtUtils.js'
import TaskActionButton from '../Task/TaskActionButton.vue'

export default {
  components: {
    TaskActionButton
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  computed: {
    displayCancelRequestMgt: function () {
      const cancelInfo = this.request.supTaskData && this.request.supTaskData.cancelInfo || null
      return !!(this.request.id && cancelInfo && !cancelInfo.cancelled && this.$d_hasRole('admin', 'dispatcher'))
    },
    disableCancelRequestMgt: function () {
      return this.displayCancelRequestMgt && !this.request.supTaskData.cancelInfo.cancelAvailable
    },
    disableCancelRequestMgtMessage: function () {
      if (this.disableCancelRequestMgt) {
        return this.getRequestMgtCancelUnavailableMessage(this.request.supTaskData.cancelInfo)
      }
      return null
    }
  },
  methods: {
    onCancelRequestMgt: function (event, navigateFn, loadingActivity) {
      const supTaskVersions = this.request.supTaskData.supTask
      const supTask = supTaskVersions && supTaskVersions.length && supTaskVersions[supTaskVersions.length - 1] || {}
      const actionName = 'Отмена задачи ПТК АПТС'

      this.$d_ask({
        callback: (data, action) => {
          if (action === 'yes') {
            loadingActivity && loadingActivity.startLoading(actionName)
            this.cancelRequestMgt(data)
              .finally(() => {
                loadingActivity && loadingActivity.stopLoading()
              })
          }
        },
        header: actionName,
        propsConfig: {
          number: { type: 'text', label: 'Номер задачи ПТК АПТС', value: supTask.number, readonly: true },
          address: { type: 'text', label: 'Адрес', value: supTask.address, readonly: true },
          reason: { type: 'text', label: 'Причина', required: true, value: MGT_TASK_CANCEL_REASON_OPTIONS[0], options: MGT_TASK_CANCEL_REASON_OPTIONS }
        },
        buttons: [
          { key: 'yes', name: 'Подтвердить' },
          { key: 'cancel', name: 'Отмена', emitable: true, onEscape: true }
        ]
      })
    },
    getRequestMgtCancelUnavailableMessage: function (cancelInfo) {
      let message
      if (cancelInfo.cancelled) {
        message = 'Задача ПТК АПТС уже отменена'
      } else if (!cancelInfo.matchBPState) {
        message = 'Статус заявки «' + this.request.bpStateName + '» не удовлетворяет условиям отмены задачи ПТК АПТС'
      } else if (!cancelInfo.matchSupStatus) {
        message = 'Текущий статус задачи: ' + cancelInfo.statusName
        if (cancelInfo.statusTimeoutExceeded) {
          message = message + '. Истек разрешенный срок изменений (30 дней)'
        } else {
          message = message + '. Статус не удовлетворяет условиям отмены'
        }
      }
      if (message == null) {
        message = 'Задача ПТК АПТС не может быть отменена'
      }
      return message
    },
    cancelRequestMgt: function (props) {
      const params = new URLSearchParams()
      params.append('id', this.request.id)
      if (props && props.reason) {
        params.append('reason', props.reason)
      }

      return axiosGet({
        url: '/service/delta/request/cancelSupTask?' + params.toString(),
        onSuccess: (response) => {
          const supTaskData = response.data.result
          this.request.supTaskData = supTaskData

          this.$q.notify({
            type: 'positive',
            message: response.data && response.data.message || 'Задача ПТК АПТС отменена',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (response) => {
          let message
          let caption
          if (response.code === 'timeout') {
            message = 'Истек таймаут запроса отмены задачи ПТК АПТС'
            caption = 'Повторите операцию, при повторной ошибке обратитесь к администратору.'
          } else {
            message = 'Ошибка отмены задачи ПТК АПТС'
            const result = response.result
            if (result && result.cancelInfo && result.cancelInfo.cancelAvailable === false) {
              this.request.supTaskData = result

              caption = this.getRequestMgtCancelUnavailableMessage(result)
            } else {
              caption = response && response.message || null
            }
          }

          this.$q.notify({
            type: 'negative',
            message: message,
            caption: caption,
            timeout: 8000,
            progress: true
          })
        }
      })
    }
  }
}

